import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '@/utils/auth'
import { getAllVehiclesOptions } from '@/api/main/@tanstack/react-query.gen'
import { useQuery } from '@tanstack/react-query'
import PageShell from '@/components/Common/PageShell'
import { CenteredLoader } from '@/components/CenteredLoader'
import ErrorState from '@/components/Common/ErrorState'
import useBodyDataProperty from '@/hooks/useDataProperty'
import Navigaton from '@/components/Navigation/Navigation'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/car-navigation/$source')({
  component: CarNavigationPage,
  beforeLoad: () => requirePermission('dispatching'),
})

function CarNavigationPage() {
  const { source } = Route.useParams()
  const { t } = useTranslation('routeManagement')

  useBodyDataProperty('data-navigation-active')

  const { data: vehicles, isLoading: isLoadingVehicles } = useQuery({
    ...getAllVehiclesOptions(),
  })

  if (isLoadingVehicles) {
    return (
      <PageShell title={t('carNavigation')} fullWidth>
        <CenteredLoader />
      </PageShell>
    )
  }

  const invalidSource = !vehicles?.some(({ id }) => id === source)

  if (invalidSource) {
    return (
      <PageShell title={t('carNavigation')} fullWidth>
        <ErrorState title={t('invalidSource')} message={t('invalidSourceMessage')} />
      </PageShell>
    )
  }

  return <Navigaton key={source} vehicleId={source} fullscreen={false} />
}
